import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        window.dispatchEvent(new CustomEvent("m-refresh-widgets"));
    }

    destroy() {
        super.destroy()
    }
}
